// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".gridLoader[data-v-4a7a8a92] {\n  display: inline-block;\n  width: 32%;\n}", "",{"version":3,"sources":["webpack://./src/components/contentloaders.vue"],"names":[],"mappings":"AACC;EACK,qBAAA;EACL,UAAA;AAAD","sourcesContent":["\n .gridLoader {\n     \tdisplay: inline-block;\n\twidth: 32%;\n }\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
